<template>
  <a-card bordered>
    <span slot="title">
      <div class="m-display-flex space-between">
        <div>
          <a-tag color="green">{{ mode == "Create" ? "Create" : "Edit" }}</a-tag>
          Evaluation Supplier
        </div>
      </div>
    </span>

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="Supplier Name" prop="supplier_name">
            <a-input v-model="form.supplier_name" disabled/>
          </a-form-model-item>
          <a-form-model-item label="Address" prop="address">
            <a-input v-model="form.address" disabled/>
          </a-form-model-item>
          <a-form-model-item label="Contact Person" prop="contact_person">
            <a-input v-model="form.contact_person" disabled/>
          </a-form-model-item>
          <a-form-model-item label="Type Product" prop="type_of_product">
            <a-input v-model="form.type_of_product" disabled/>
          </a-form-model-item>
          <a-form-model-item label="Category" prop="category">
            <a-input v-model="form.category" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="Price" prop="price">
            <a-select showSearch v-model="form.price"
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="changeType"
            >
              <a-select-option v-for="item in form.listprice" :key="item.value">
                {{item.text}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="Quality" prop="quality">
            <a-select showSearch v-model="form.quality"
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="changeType"
            >
              <a-select-option v-for="item in form.listquality" :key="item.value">
                {{item.text}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="Service" prop="service">
            <a-select showSearch v-model="form.service"
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="changeType"
            >
              <a-select-option v-for="item in form.listservice" :key="item.value">
                {{item.text}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="Risk Analysis" prop="riskAnalysis">
            <a-select showSearch v-model="form.riskAnalysis"
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="changeType"
            >
              <a-select-option v-for="item in form.listriskAnalysis" :key="item.value">
                {{item.text}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="Note" prop="catatan">
            <a-textarea v-model="form.catatan" :rows="5"></a-textarea>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <div slot="actions">
      <div class="m-display-flex space-between">
        <div class="act-total-rating">
          <span> Total Ratings : {{total_rating}} Point </span>
        </div>
      <a-button :loading="loading.submit" type="primary" @click="handleSave()">Save</a-button>
      </div>
    </div>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import Axios from "axios";

export default {
  name: "supplierEvaluation-create",
  props: ["id","type"],
  mixins: [GlobalMethod],
  data() {
    return {
      mode: "Create",
      loading: {
        submit: false,
      },
      form: {
        id_supplier: null,
        price: null,
        quality: null,
        service: null,
        riskAnalysis: null,
        catatan: null,
      },
      rules: {
        price: {
          required: true,
          message: "Please input price evaluation",
          trigger: "blur",
        },
        quality: {
          required: true,
          message: "Please input quality evaluation",
          trigger: "blur",
        },
        service: {
          required: true,
          message: "Please input service evaluation",
          trigger: "blur",
        },
        riskAnalysis: {
          required: true,
          message: "Please input risk analysis evaluation",
          trigger: "blur",
        },
        catatan: {
          required: false,
          message: "Please input Note",
          trigger: "blur",
        },
      },
      total_rating: 0,
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate",]),
  },
  watch: {
  },
  mounted() {
    if(this.type=="revised")
      this.mode = "Edit";
    this.fetch();
  },
  methods: {
    moment,
    fetch() {
      Axios({
        method: "get",
        url: this.$serviceUrl + 
          (this.mode=="Create" ? "evaluasi_suplier/pilih_suplier" : "evaluasi_suplier/edit_evaluasi_suplier"),
        params: this.mode=="Create" ? {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_supplier: this.id,
        } : {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_evaluasi_supplier: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        this.form = {
          id_supplier: this.type=="revised" ? response.data.id : response.data.id_supplier,
          price: this.type=="revised" ? response.data.harga: null,
          quality: this.type=="revised" ? response.data.mutu: null,
          service: this.type=="revised" ? response.data.pelayanan: null,
          riskAnalysis: this.type=="revised" ? response.data.risiko: null,
          catatan: this.type=="revised" ? response.data.catatan: null,
          listprice: response.data.price,
          listquality: response.data.quality,
          listservice: response.data.service,
          listriskAnalysis: response.data.risk_analysis,
          supplier_name: response.data.supplier_name,
          address: response.data.addres,
          contact_person: response.data.contact_person,
          type_of_product: response.data.type_of_product,
          category: response.data.category,
        }
      })
      .catch((err) => {
        console.log(err);
        if (!err.response) {
          let responses = Object.assign({}, err.response.data);
          console.log(responses);
          this.displayMessageValue("error", responses);
          this.$router.go(-1);
        } else {
          this.displayMessage("denied-manifest");
          this.$router.push({ name: "beranda" });
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    changeType(){
      this.total_rating = 
        Number(this.form.price)+Number(this.form.quality)+Number(this.form.service)
        +Number(this.form.riskAnalysis);
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        
        this.loading.submit = true;

        let data = new FormData();
        if (this.type=="revised"){
          data.append("id_eval_supp",this.form.id_supplier);
        }else{
          data.append("id_supplier",this.form.id_supplier);
        }
        data.append("tlc",this.getAuth.username);
        data.append("price",this.form.price);
        data.append("quality",this.form.quality);
        data.append("service",this.form.service);
        data.append("risk_analysis",this.form.riskAnalysis);
        data.append("catatan",this.form.catatan ? this.form.catatan : "");

        Axios({
          method: "post",
          url: this.$serviceUrl + "evaluasi_suplier" + (this.type=="revised" ? '/edit' : ''),
          data: data,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.displayMessage("success");
          this.$router.push({ name: "supplierEvaluationPurchasing" });
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: @padding -@padding -@padding -@padding;
  padding: @padding;
  background-color: darken(white, 5);
  border-top: 1px solid darken(white, 10);
}
.act-total-rating{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: bolder;
  font-size: 125%;
  color: @color-primary;
}
</style>
